<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <span />
      </template>
    </app-breadcrumb>

    <!-- Table Container Card -->
    <b-row>
      <b-col
        md="6"
        offset-md="3"
      >
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-card
            title="Danh sách nhóm người dùng"
            class="mb-0"
          >

            <b-card-text>
              Cấp tài khoản MAM cho nhóm người dùng
            </b-card-text>

            <b-list-group>
              <b-list-group-item
                v-for="(item) in itemsData"
                :key="item.id"
                class="d-flex justify-content-between align-items-center"
              >
                <div>
                  <div class="text-primary">
                    <strong>{{ item.name }}</strong>
                  </div>
                  <div class="text-muted">
                    {{ item.description }}
                  </div>
                  <div>
                    <strong
                      v-for="ac in item.mam_accounts"
                      :key="`ac` + ac.id"
                    >Tài khoản MAM: {{ ac.name }}</strong>
                  </div>
                </div>
                <div>
                  <b-button
                    v-b-tooltip
                    variant="flat-secondary"
                    class="btn-icon"
                    title="Gán tài khoản MAM"
                    @click="openModal(item)"
                  >
                    <feather-icon icon="UserPlusIcon" />
                  </b-button>
                  <b-button
                    v-b-tooltip
                    variant="flat-danger"
                    class="btn-icon"
                    title="Hủy tài khoản MAM"
                    @click="removeGroupAccount(item)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </div>
              </b-list-group-item>
            </b-list-group>

          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
    <!-- modal login-->
    <b-modal
      id="modal-assign-position"
      title="Danh sách tài khoản MAM"
      size="lg"
      :ok-only="true"
      ok-title="Đóng"
      hide-footer
      centered
    >
      <b-overlay
        :show="loadingAssign"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-list-group>
          <b-list-group-item
            v-for="(item, index) in itemAccounts"
            :key="item.id"
            class="d-flex justify-content-between align-items-center"
          >
            <div>
              <div class="text-primary">
                <strong>{{ item.name }}</strong>
              </div>
              <div class="text-muted">
                {{ item.description }}
              </div>
              <div>{{ item.username }}</div>
            </div>
            <div>
              <b-button
                variant="flat-secondary"
                class="btn-icon"
                @click="addToGroup(item)"
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BOverlay, BCard, BListGroup, BListGroupItem, BButton,
  BCardText, BRow, BCol, BModal,
  VBTooltip,
} from 'bootstrap-vue'
import { ref, reactive } from '@vue/composition-api'
import { showToast } from '@/@core/utils/utils'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import store from '@/store';
import useGroups from '../groups/useGroups'

export default {
  components: {
    AppBreadcrumb,
    BOverlay,
    BRow,
    BCol,
    BCard,
    BCardText,
    BButton,
    BListGroup,
    BListGroupItem,
    BModal,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      title: '',
    }
  },
  setup() {
    const loadingAssign = ref(false)
    const selectedGroupId = ref(0)
    const itemsData = ref([])
    const itemAccounts = ref([])

    const {
      loading,
      searchQuery,
      perPage,
      currentPage,
      sortBy,
      isSortDirDesc,
      isPaginate,
      totalEntries,
      fetchGroups,
    } = useGroups();

    const fetchGroupsWithAccount = () => {
      loading.value = true;
      fetchGroups((items) => {
        const groupIds = [];

        if (items.length) {
          items.forEach(v => {
            groupIds.push(v.id);
          });
        }
        loading.value = true;
        store
          .dispatch('files/fetchMamGroupAccounts', {
            group_id: groupIds.join(','),
            perPage: 9999,
            isPaginate: 0,
            withAccount: 1,
          })
          .then((response) => {
            loading.value = false;
            if (response.status === 200) {
              const list = response.data.data;
              if (list) {
                list.forEach(it => {
                  const group = items.find((v) => v.id === it.group_id);
                  if (group) {
                    group.mam_accounts = it.mam_accounts;
                  }
                })
              }
            }
            itemsData.value = items;
          })
      });
    }
    const fetchMAMAccounts = () => {
      store
        .dispatch('files/fetchMamAccounts', {
          perPage: 999,
          isPaginate: false,
        })
        .then((response) => {
          if (response.status === 200) {
            const items = response.data.data.data;
            itemAccounts.value = items;
          }
        });
    }

    fetchGroupsWithAccount();
    fetchMAMAccounts();

    return {
      loading,
      loadingAssign,
      searchQuery,
      perPage,
      currentPage,
      sortBy,
      isSortDirDesc,
      isPaginate,
      itemsData,
      totalEntries,
      fetchGroupsWithAccount,
      itemAccounts,
      selectedGroupId,
    }
  },

  methods: {
    openModal(item) {
      this.selectedGroupId = item.id;
      this.title = item ? 'Cập nhật tài khoản' : 'Tạo mới tài khoản';
      this.itemData = item
      this.$bvModal.show('modal-assign-position')
    },
    addToGroup(account) {
      const vm = this;
      this.loadingAssign = true;
      store
        .dispatch('files/addMamGroupAccounts', {
          mam_account_id: account.id,
          group_id: this.selectedGroupId,
        })
        .then((response) => {
          this.loadingAssign = false;
          if (response.status === 200) {
            const groupIdx = vm.itemsData.findIndex((v) => v.id === this.selectedGroupId);
            const groupData = vm.itemsData[groupIdx];
            groupData.mam_accounts = response.data.data;
            vm.$set(vm.itemsData, groupIdx, groupData);
            this.$bvModal.hide('modal-assign-position')
          }
        });
    },
    removeGroupAccount(item) {
      const vm = this;
      this.$swal({
        title: 'Bạn chắc muốn xóa?',
        text: 'Xóa dữ liệu sẽ ảnh hưởng đến các chức năng khác trong hệ thống!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('files/destroyMamGroupAccount', { id: item.id }).then((res) => {
            if (res.status === 200) {
              const groupIdx = this.itemsData.findIndex((v) => v.id === item.id);
              const groupData = vm.itemsData[groupIdx];
              groupData.mam_accounts = [];
              vm.$set(vm.itemsData, groupIdx, groupData);
              showToast(res.data.message, { variant: 'success' });
            } else {
              showToast(res.data.message);
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
